#import '../fragments/marketing-automation-fragment.graphql'

mutation CreateMoneyPageAutomation($input: UrlAutomationCreateInput!) {
    maUrlAutomationCreate(input: $input) {
        automation {
            ...MarketingAutomationFragment
        }
    }
}
